export default __webpack_public_path__ + "static/media/ourmission.9d2e2a69.webp";